import { Status } from 'src/shared/models';

const SIN_CONTEO_MINUTOS_LIMITE = 4 * 60;
const HORA_CIERRE = 22;
const HORA_APERTURA = 6;

export function isSinConteo(status: Status | string, sinConteo?: string, ultimoConteo?: Date | string): boolean {
  if (status !== Status.online || !sinConteo) return false;

  const ultimaFecha = ultimoConteo ? new Date(ultimoConteo) : null;
  if (!ultimaFecha || isNaN(ultimaFecha.getTime())) {
    const [horas, minutos] = sinConteo.split(':').map((value) => parseInt(value, 10) || 0);
    return (horas * 60 + minutos) > SIN_CONTEO_MINUTOS_LIMITE;
  }

  const minutosEfectivos = getMinutosSinConteoEfectivos(ultimaFecha, new Date());
  return minutosEfectivos > SIN_CONTEO_MINUTOS_LIMITE;
}

function getMinutosSinConteoEfectivos(desde: Date, hasta: Date): number {
  let minutos = 0;
  let cursor = desde;

  while (cursor < hasta) {
    const finTramo = new Date(Math.min(siguienteLimiteHorario(cursor).getTime(), hasta.getTime()));

    if (!estaEnHorarioCierre(cursor)) {
      minutos += (finTramo.getTime() - cursor.getTime()) / 60000;
    }

    cursor = finTramo;
  }

  return minutos;
}

function estaEnHorarioCierre(fecha: Date): boolean {
  const hora = fecha.getHours();
  return hora >= HORA_CIERRE || hora < HORA_APERTURA;
}

function siguienteLimiteHorario(fecha: Date): Date {
  const siguiente = new Date(fecha);
  const hora = fecha.getHours();

  if (hora < HORA_APERTURA) {
    siguiente.setHours(HORA_APERTURA, 0, 0, 0);
  } else if (hora < HORA_CIERRE) {
    siguiente.setHours(HORA_CIERRE, 0, 0, 0);
  } else {
    siguiente.setDate(siguiente.getDate() + 1);
    siguiente.setHours(HORA_APERTURA, 0, 0, 0);
  }

  return siguiente;
}
